/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  // useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Junny Lim",
  logo_name: "Junny Lim",
  nickname: "Sweet",
  full_name: "Junny Lim",
  subTitle:
    "Experienced Full Stack Developer with a Passion for Innovation.",
  resumeLink:
    "./Resume.pdf",
  mail: "mailto:lovelysweet1017@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/lovelysweet1017",
  // linkedin: "https://www.linkedin.com/in/junnylim1017/",
  skype: "live:.cid.b4a5d6dadb46e0a4",
  gmail: "lovelysweet1017@gmail.com",
  telegram: "https://t.me/lovelysweet24",
};


const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developing full-stack applications using a range of programming languages",
        "⚡ Building functional web applications using popular frameworks and libraries",
        "⚡ Utilizing effective methodologies and tools for design, development and deploy",
        "⚡ Elevating user experiences, driving business growth through strategic tech solutions",
      ],
      softwareSkills: [
        {
          skillName: "HTML",
          fontAwesomeClassname: "skill-icons:html",
          style: {
            color: "#E44D26",
          },
        },
        {
          skillName: "CSS",
          fontAwesomeClassname: "skill-icons:css",
          style: {
            color: "#264DE4",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "skill-icons:javascript",
          style: {
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {
            color: "#007ACC",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "devicon:cakephp",
          style: {
            color: "#777BB4",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "twemoji:letter-r",
          style: {
            color: "#276DC3",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "logos:c-sharp",
          style: {
            color: "#0078D7",
          },
        },
        {
          skillName: "Ruby",
          fontAwesomeClassname: "logos:ruby",
          style: {
            color: "#0078D7",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos:python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "devicon:mongodb",
          style: {
            color: "#4DB33D",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "fontisto:mysql",
          style: {
            color: "#00758F",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "logos:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "skill-icons:aws-dark",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: ".Net",
          fontAwesomeClassname: "skill-icons:dotnet",
          style: {
            color: "#888888",
          },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "devicon:nodejs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "devicon:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Vue.js",
          fontAwesomeClassname: "fontisto:vuejs",
          style: {
            color: "#4FC08D",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "devicon:angularjs",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "skill-icons:nextjs-dark",
          style: {
            color: "#FFFFFF",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "mdi:laravel",
          style: {
            color: "#FF2D20",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "skill-icons:django",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#1ABC9C",
          },
        },
        {
          skillName: "Pytorch",
          fontAwesomeClassname: "devicon:pytorch",
          style: {
            color: "#EE4C2C",
          },
        },
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos:tensorflow",
          style: {
            color: "#FF6F00",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "devicon:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "WordPress",
          fontAwesomeClassname: "skill-icons:wordpress",
          style: {
            color: "#21759B",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "logos:firebase",
          style: {
            color: "#21759B",
          },
        },
        {
          skillName: "Photoshop",
          fontAwesomeClassname: "iconoir:adobe-photoshop",
          style: {
            color: "#31A8FF",
          },
        },
        {
          skillName: "Agile/Scrum",
          fontAwesomeClassname: "iconoir:agile",
          style: {
            color: "#6CBEEF",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "devicon:git",
          style: {
            color: "#888888",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "mdi:github",
          style: {
            color: "#888888",
          },
        },
        {
          skillName: "Thingsboard",
          fontAwesomeClassname: "eos-icons:iot",
          style: {
            color: "#FFFF00",
          },
        },
        {
          skillName: "Matlab",
          fontAwesomeClassname: "vscode-icons:file-type-matlab",
          style: {
            color: "#888888",
          },
        },
        {
          skillName: "Arduino",
          fontAwesomeClassname: "skill-icons:arduino",
          style: {
            color: "#888888",
          },
        },
        {
          skillName: "RaspberryPi",
          fontAwesomeClassname: "logos:raspberry-pi",
          style: {
            color: "#888888",
          },
        },
      ],
    },
    // {
    //   title: "Blockchain Development",
    //   fileName: "BlockchainImg",
    //   skills: [ 
    //     "⚡ Developing blockchain solutions using various programming languages",
    //     "⚡ Utilizing advanced development tools and frameworks",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Solidity",
    //       fontAwesomeClassname: "skill-icons:solidity",
    //       style: {
    //         color: "#0066CC"
    //       },
    //     },
    //     {
    //       skillName: "Solana",
    //       fontAwesomeClassname: "mingcute:solana-sol-fill",
    //       style: {
    //         color: "#0088CC"
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "skill-icons:javascript",
    //       style: {
    //         color: "#F7DF1E",
    //       },
    //     },
    //     {
    //       skillName: "C++",
    //       fontAwesomeClassname: "file-icons:c",
    //       style: {
    //         color: "#662996",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "logos:python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Java",
    //       fontAwesomeClassname: "logos:java",
    //       style: {
    //         color: "#007396",
    //       },
    //     },
    //     {
    //       skillName: "Go",
    //       fontAwesomeClassname: "skill-icons:golang",
    //       style: {
    //         color: "#00ADD8",
    //       },
    //     },
    //     {
    //       skillName: "Web3.js",
    //       fontAwesomeClassname: "logos:web3js",
    //       style: {
    //         color: "#F16822",
    //       },
    //     },
    //     {
    //       skillName: "Ether.js",
    //       fontAwesomeClassname: "logos:ethers",
    //       style: {
    //         color: "#3C3C3D",
    //       },
    //     },
    //     {
    //       skillName: "Fabric",
    //       fontAwesomeClassname: "logos:fabric",
    //       style: {
    //         color: "#0B3D91",
    //       },
    //     },
    //     {
    //       skillName: "Ethereum",
    //       fontAwesomeClassname: "logos:ethereum-color",
    //       style: {
    //         color: "#339933",
    //       },
    //     },
    //     {
    //       skillName: "Truffle",
    //       fontAwesomeClassname: "logos:truffle-icon",
    //       style: {
    //         color: "#7B43A1",
    //       },
    //     },
    //     {
    //       skillName: "Remix",
    //       fontAwesomeClassname: "skill-icons:remix-dark",
    //       style: {
    //         color: "#4CAF50",
    //       },
    //     },
    //     {
    //       skillName: "Ganache",
    //       fontAwesomeClassname: "logos:ganache-icon",
    //       style: {
    //         color: "#FFA726",
    //       },
    //     },
    //     {
    //       skillName: "Metamask",
    //       fontAwesomeClassname: "logos:metamask-icon",
    //       style: {
    //         color: "#E2761B",
    //       },
    //     },
    //   ],
    // },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Hong Kong University of Science and Technology",
      subtitle: "Bachelor's degree in Computer Science",
      logo_path: "hkust.png",
      alt_name: "HKUST",
      duration: "2013 - 2017",
      descriptions: [
        "⚡ Won Merit and Leadership scholarships",
        "⚡ Landed an part-time job in my field of study",
        "⚡ Graduated with Summa Cum Laude",
      ],
      website_link: "https://hkust.edu.hk/",
    }
  ],
};

const certifications = {
  certifications: [
    {
      title: "Responsive Web Design",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/responsive-web-design",
      alt_name: "FreeCodeCamp",
      color_code: "#EFE1CE",
    },
    {
      title: "Javascript Algorithms and Data Structures",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/javascript-algorithms-and-data-structures",
      alt_name: "FreeCodeCamp",
      color_code: "#0072B5",
    },
    {
      title: "Front End Development Libraries",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/front-end-development-libraries",
      alt_name: "FreeCodeCamp",
      color_code: "#E3405F",
    },
    {
      title: "Data Visualization",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/data-visualization",
      alt_name: "FreeCodeCamp",
      color_code: "#B55A30",
    },
    {
      title: "Legacy Front End",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/legacy-front-end",
      alt_name: "FreeCodeCamp",
      color_code: "#9BB7D4",
    },
    {
      title: "Legacy Data Visualization",
      subtitle: "FreeCodeCamp",
      logo_path: "fcc/white.png",
      certificate_link: "https://www.freecodecamp.org/certification/fccb2a88230-af40-48bc-9d8e-67b5859abe60/legacy-data-visualization",
      alt_name: "FreeCodeCamp",
      color_code: "#939597",
    },
    {
      title: "Angular (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/83617ac169f3",
      alt_name: "HackerRank",
      color_code: "#EFE1CE",
    },
    {
      title: "Angular (Intermediate)",
      subtitle: "HackerRank",
      logo_path: "hrtest/burgundy.png",
      certificate_link: "https://www.hackerrank.com/certificates/8977103a6b28",
      alt_name: "HackerRank",
      color_code: "#EFE1CE",
    },
    {
      title: "C# (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/f622785e743b",
      alt_name: "HackerRank",
      color_code: "#0072B5",
    },
    {
      title: "Java (Basic)",
      subtitle: "HakerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/b71212cabda9",
      alt_name: "HakerRank",
      color_code: "#E3405F",
    },
    {
      title: "JavaScript (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/4dfe671de9f7",
      alt_name: "HackerRank",
      color_code: "#9BB7D4",
    },
    {
      title: "JavaScript (Intermediate)",
      subtitle: "HackerRank",
      logo_path: "hrtest/burgundy.png",
      certificate_link: "https://www.hackerrank.com/certificates/855b67e8d96f",
      alt_name: "HackerRank",
      color_code: "#9BB7D4",
    },
    {
      title: "Problem Solving (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/c39f6488000d",
      alt_name: "HackerRank",
      color_code: "#939597",
    },
    {
      title: "Python (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/599c7e44657c",
      alt_name: "HackerRank",
      color_code: "#0072B5",
    },
    {
      title: "R (Intermediate)",
      subtitle: "HackerRank",
      logo_path: "hrtest/burgundy.png",
      certificate_link: "https://www.hackerrank.com/certificates/6d9fa1c42ec8",
      alt_name: "HackerRank",
      color_code: "#FFDB58",
    },
    {
      title: "React (Basic)",
      subtitle: "HackerRank",
      logo_path: "hrtest/white.png",
      certificate_link: "https://www.hackerrank.com/certificates/f055edb0320d",
      alt_name: "HackerRank",
      color_code: "#B55A30",
    },
    // {
    //   title: "SQL (Basic)",
    //   subtitle: "HackerRank",
    //   logo_path: "hrtest/white.png",
    //   certificate_link: "https://www.hackerrank.com/certificates/cf6403bf3020",
    //   alt_name: "HackerRank",
    //   color_code: "#FFFFE0",
    // },
    {
      title: "SQL (Intermediate)",
      subtitle: "HackerRank",
      logo_path: "hrtest/burgundy.png",
      certificate_link: "https://www.hackerrank.com/certificates/e3f9f04ca22a",
      alt_name: "HackerRank",
      color_code: "#FFFFE0",
    },
    {
      title: "SQL (Advanced)",
      subtitle: "HackerRank",
      logo_path: "hrtest/charcoal.png",
      certificate_link: "https://www.hackerrank.com/certificates/566cb0ab1bf3",
      alt_name: "HackerRank",
      color_code: "#FFFFE0",
    },
  ],
};

// Experience Page
const experience = {
  title: "Professional Experience",
  subtitle: "Full-stack Developer with 6+ years of experience",
  description: [
    "Awesome Work and Ontime Delivery. Good support received from Junny.",
    "JunHao has an exceptional troubleshooting and analytical skills in WEB.",
    "JunHao is a great asset to any company. - Ciaran Lee, CTO of Intercom.",
  ],
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Senior Frontend Developer",
      experiences: [
        {
          title: "Intercom",
          company: "Intercom",
          company_url: "https://www.intercom.com/careers/dublin",
          logo_path: "intercom1.png",
          duration: "March 2021 - May 2023",
          location: "Dublin, Ireland (Remote)",
          summary:
            " Intercom is a customer relationship management (CRM) platform that helps businesses engage with their customers through messaging, in-app chat, and email. ",
          description:
            [
            "⚡ Worked with advance web development technologies like React, Node, Express, MongoDB, MySQL, ECMAScript, Typescript, JavaScript, Immutable, Python, PHP, Bootstrap4, CSS3, HTML5 Object Notation.",
            "⚡ Increased efficiency by deprecating unneeded API calls, resulting in a 15% reduction in server response time.",
            "⚡ Developed high volume, high-scale web front ends for assets requiring responsive designs, which improved user engagement by 25%.",
            "⚡ Implemented custom Redux Form scripts for updating Redux store using immutable and Redux Thunk and Saga, resulting in a 30% improvement in data processing time.",
            "⚡ Successfully configured CircleCI to continuously integrate and deploy (CI/CD) code, reducing deployment time by 40%.",
            "⚡ Enforced Agile and Scrum development methodologies on interface projects, which resulted in a 20% reduction in development times.",
            "⚡ Added hooks in the project and moved some class-based components to functional components, resulting in a 15% improvement in overall application performance."
            ],
          color: "#7F001F",
        },
      ],
    },
    {
      title: "Full Stack Developer",
      experiences: [
        {
          title: "Goxip Inc",
          company: "Goxip Inc",
          company_url: "https://www.goxip.com/",
          logo_path: "goxip.png",
          duration: "June 2018 - February 2021",
          location: "Hong Kong",
          summary:
            " Goxip Inc. is a fashion and beauty discovery platform based in Hong Kong. Goxip allows users to discover new fashion and beauty products by scanning images of celebrities, influencers, and other users.",
          description:
            ["⚡ Developed 5 web services using PHP, Python, Node.js, React.js, and Vue.js, enabling communications with other trading desk applications via REST, SOAP, JSON, and custom XML messages. Increased active users by 20% in the first year.",
            "⚡ Worked on an Agile Development Team to deliver regular updates and meet deadlines, meeting or exceeding all project deadlines.",
            "⚡ Optimized the look and feel of web pages using SASS, reducing the number of CSS files by 50%, which improved the performance of the Goxip website.",
            "⚡ Led the development of React UI and architecture, building a components library, including Tree, Slide-View, and Table Grid, reducing the number of lines of code by 20%, which improved the maintainability of the Goxip codebase.",
            "⚡ Integrated server-side and client-side code on AWS, reducing the cost of hosting the Goxip website by 20%.",
            "⚡ Used HP Quality Center to keep track of outstanding bugs, reducing the number of downtime incidents by 50%."
          ],
          color: "#35444E",
        },
      ],
    },
    {
      title: "Junior Full Stack Developer",
      experiences: [
        {
          title: "AIA Group Limited",
          company: "AIA Group Limited",
          company_url: "https://www.aia.com/",
          logo_path: "aia_group.png",
          duration: "July 2017 - May 2018",
          location: "Hong Kong",
          summary:
            " AIA Group Limited is a Hong Kong-based multinational insurance and financial services corporation. It is the largest publicly listed life insurance group in Asia-Pacific.",
          description:
            ["⚡ Developed a responsive, AngularJS-based web application that replaced a legacy system, resulting in a 30% increase in user adoption.",
            "⚡ Implemented form field validation using AngularJS, resulting in a 25% reduction in data entry errors.",
            "⚡ Enhanced user experience by designing new features using Backbone.js, resulting in a 20% increase in user satisfaction.",,
            "⚡ Converted a traditional web application to a single-page application using AJAX and a state management layer, resulting in a 40% reduction in load times.",
            "⚡ Developed E-commerce applications using HTML, PHP, Python, and CSS based on W3C standards, resulting in a 35% increase in online sales."
          ],
          color: "#35444E",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects have resulted in increased user engagement, revenue growth, and operational efficiency. I have also implemented various features such as payment gateway integration, order management system, and user authentication, resulting in a seamless shopping experience for customers. Additionally, I have achieved high availability and reliability of the platforms with a 99.9% uptime rate and reduced downtime incidents by 60%. I have successfully implemented agile methodologies for project management, resulting in a 30% increase in development speed and improved team collaboration.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      name: "Intercom Journey",
      url: "https://www.intercom.com/product-tours",
      description:
        "Customer onboarding and engagement tool that helps businesses guide users through their product.",
      stack: ["HTTP/3", "React", "Next.js"],
    },
    {
      name: "Intercom Conversations",
      url: "https://www.intercom.com/app-store?category=conversation-management",
      description:
        "Customer messaging platform that allows businesses to communicate with their customers in real time.",
      stack: ["Ember.js", "React", "Nuxt.js"],
    },
    {
      name: "Online TV Shows",
      url: "https://bertflix.vercel.app/",
      description:
        "Watch TV shows Online, Watch Movie Online",
      stack: ["Node.js", "React.js", "TypeScript"],
    },
    {
      name: "Goxip Flash Sale",
      url: "https://theflashsale.com/",
      description:
        "Daily event where select products are discounted for a limited time. Great way to find great deals on high-quality products.",
      stack: ["Angular", "Node.js", "Express.js", "TypeScript"],
    },
    {
      name: "Shop Live",
      url: "https://www.goxip.com/gs/en/designers/live",
      description:
        "Goxip offers live shopping events, where users can interact with brands and influencers in real time.",
      stack: ["Vue.js", "Bootstrap", "jQuery"],
    },
    {
      name: "Harbour City",
      url: "https://www.harbourcity.com.hk/en/",
      description: "One of the largest shopping malls in Hong Kong",
      stack: ["PHP", "MySQL", "WordPress", "jQuery"],
    },
    {
      name: "AIA Vitality",
      url: "https://www.aia.com/en/health-wellness/vitality",
      description:
        "Health and wellness program that helps people live healthier lives",
      stack: ["JavaScript", "Bootstrap", "jQuery"],
    },
    {
      name: "Devilbox",
      url: "http://devilbox.org/",
      description:
        "Docker LAMP development stack with valid https support",
      stack: ["Angular", "Node", "jQuery"],
    },
    {
      name: "AIA Digital Assistant",
      url: "https://www.globaldata.com/store/report/aia-group-enterprise-tech-analysis/",
      description:
        "Chatbot that helps customers with their insurance needs",
      stack: ["WordPress", "PHP", "MySQL"],
    },
    {
      name: "ZJON",
      url: "https://www.zjson.net/",
      description:
        "Powerful tool that can be used to format, minify, and pretty print JSON data",
      stack: ["Angular","Node","TypeScript"],
    },
    {
      name: "Healthchecks",
      url: "https://healthchecks.io/",
      description:
        "Service that helps you monitor your applications and services. ",
      stack: ["Python", "Django", "PostreSQL"],
    },
    {
      name: "Ovolo Hotels",
      url: "https://ovolohotels.com/",
      description:
        "Innovative and engaging booking experience for customersg",
      stack: ["PHP", "MySQL", "WordPress", "jQuery"],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  projects,
};
